// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import { registerControllers } from "stimulus-vite-helpers"


const application = Application.start()
const controllers = import.meta.glob("./**/*_controller.js", { eager: true })
// コントローラーを登録
registerControllers(application, controllers)

// デバッグ用（ブラウザ上のコンソールでwindow.Stimulusと入力するとオブジェクトの中身をチェックできる
// router.modulesByIdentifierにdata-controllerで指定するキーが表示できる）
//window.Stimulus = application
//application.debug = true